"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeDefaultContractClient = void 0;
const viem_1 = require("viem");
const make_transport_1 = require("../make-transport");
const makeDefaultContractClient = (account, chain, urlOrProvider) => {
    const transport = (0, make_transport_1.makeTransport)(urlOrProvider);
    const client = (0, viem_1.createWalletClient)({
        account,
        chain,
        transport,
    }).extend(viem_1.publicActions);
    return { ...client, isCallWithSenderSupported: false };
};
exports.makeDefaultContractClient = makeDefaultContractClient;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmYXVsdC1jb250cmFjdC1jbGllbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvaW1wbC9kZWZhdWx0LWNvbnRyYWN0LWNsaWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSwrQkFBa0Y7QUFHbEYsc0RBQWlEO0FBRTFDLE1BQU0seUJBQXlCLEdBQUcsQ0FDdkMsT0FBMEIsRUFDMUIsS0FBWSxFQUNaLGFBQW9ELEVBQ3BDLEVBQUU7SUFDbEIsTUFBTSxTQUFTLEdBQUcsSUFBQSw4QkFBYSxFQUFDLGFBQWEsQ0FBQyxDQUFBO0lBQzlDLE1BQU0sTUFBTSxHQUFHLElBQUEseUJBQWtCLEVBQUM7UUFDaEMsT0FBTztRQUNQLEtBQUs7UUFDTCxTQUFTO0tBQ1YsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxvQkFBYSxDQUFDLENBQUE7SUFFeEIsT0FBTyxFQUFFLEdBQUcsTUFBTSxFQUFFLHlCQUF5QixFQUFFLEtBQUssRUFBRSxDQUFBO0FBQ3hELENBQUMsQ0FBQTtBQWJZLFFBQUEseUJBQXlCLDZCQWFyQyJ9